import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ButtonEventsService } from '../../services/button-events.service';
import { CmxLayoutService } from '../../services/cmx-layout.service';

@Component({
  selector: 'cmx-footer',
  templateUrl: './cmx-footer.component.html',
  styleUrls: ['./cmx-footer.component.scss'],
})
export class CmxFooterComponent implements OnInit, OnDestroy {
  public version: number;

  private subscriptions: Subscription[] = [];

  constructor(
    public buttons: ButtonEventsService,
    public layout: CmxLayoutService,
  ) {}

  ngOnInit() {
    this.subscriptions.push(this.layout.version.subscribe((value) => (this.version = value)));
  }

  onSelect(value: 'left' | 'right') {
    if (value === 'left') {
      this.layout.directionSelect.emit('ltr');
      return;
    }
    if (value === 'right') {
      this.layout.directionSelect.emit('rtl');
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
